import { create } from 'zustand';
import type { AuthUser } from '@authsemply/shared';
import { api } from '../lib/api';

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
  mfaToken: string | null;
  setUser: (user: AuthUser | null) => void;
  setMfaToken: (token: string | null) => void;
  fetchMe: () => Promise<void>;
  logout: () => Promise<void>;
}

/** Au-delà, la session est tenue pour absente : un écran ne doit jamais attendre sans fin une réponse qui ne vient pas. */
export const DELAI_SESSION_MS = 8000;

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  mfaToken: null,
  setUser: (user) => set({ user, loading: false }),
  setMfaToken: (mfaToken) => set({ mfaToken }),
  fetchMe: async () => {
    try {
      const delai = new Promise<never>((_, rejeter) =>
        setTimeout(() => rejeter(new Error('Délai dépassé')), DELAI_SESSION_MS),
      );
      set({ user: await Promise.race([api.get<AuthUser>('/auth/me'), delai]), loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },
  logout: async () => {
    await api.post('/auth/logout');
    set({ user: null, mfaToken: null });
  },
}));
